{
  "CANNED_MGMT": {
    "HEADER": "Швидкі відповіді",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "COUNT": "{n} canned response | {n} canned responses",
    "HEADER_BTN_TXT": "Додати швидку відповідь",
    "LOADING": "Отримання швидких відповідей...",
    "SEARCH_PLACEHOLDER": "Search canned responses...",
    "NO_RESULTS": "No canned responses found matching your search",
    "SEARCH_404": "Немає елементів, що відповідають запиту.",
    "LIST": {
      "404": "В цьому обліковому записі немає швидких відповідей.",
      "TITLE": "Керування швидкими вдіповідями",
      "DESC": "Швидкі відповіді - це шаблони, які можна швидко використати для відповіді на повідомлення у діалозі.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Шорт-код",
        "CONTENT": "Вміст",
        "ACTIONS": "Дії"
      }
    },
    "ADD": {
      "TITLE": "Додати швидку відповідь",
      "DESC": "Швидкі відповіді - це шаблони, які можна швидко використати для відповіді на повідомлення у діалозі.",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Шорт-код",
          "PLACEHOLDER": "Введіть шорт-код.",
          "ERROR": "Необхідно вказати шорт-код."
        },
        "CONTENT": {
          "LABEL": "Текст повідомлення",
          "PLACEHOLDER": "Будь ласка, напишіть повідомлення, яке ви хочете зберегти як шаблон, щоб використовувати пізніше.",
          "ERROR": "Необхідно ввести повідомлення."
        },
        "SUBMIT": "Додати"
      },
      "API": {
        "SUCCESS_MESSAGE": "Швидку відповідь додано.",
        "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
      }
    },
    "EDIT": {
      "TITLE": "Редагувати швидку відповідь",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Шорт-код",
          "PLACEHOLDER": "Введіть шорт-код.",
          "ERROR": "Необхідно вказати шорт-код."
        },
        "CONTENT": {
          "LABEL": "Текст повідомлення",
          "PLACEHOLDER": "Будь ласка, напишіть повідомлення, яке ви хочете зберегти як шаблон, щоб використовувати пізніше.",
          "ERROR": "Необхідне повідомлення."
        },
        "SUBMIT": "Додати"
      },
      "BUTTON_TEXT": "Редагувати",
      "API": {
        "SUCCESS_MESSAGE": "Швидку відповідь успішно оновлено.",
        "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Видалити",
      "API": {
        "SUCCESS_MESSAGE": "Швидку відповідь успішно видалено.",
        "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
      },
      "CONFIRM": {
        "TITLE": "Підтвердіть видалення",
        "MESSAGE": "Справді бажаєте видалити ",
        "YES": "Так, видалити ",
        "NO": "Ні, залишити "
      }
    }
  }
}
